import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { Exam } from '../../db/exam.js';
import { Submission } from '../../db/submission.js';

export const getExamStatusQuery = registerQuery({
  operationName: 'getExamStatusQuery',
  type: () => String,
  params: [{ name: 'examId', type: () => String }],
  resolve: (examId: string) => async (): Promise<string> => {
    const examCollection = await getCollection(Exam);
    const currentExam = await examCollection.findOne({ _id: examId });

    const status = {
      submissions: false,
      masterSolution: false,
      gradingScheme: false,
      blankExam: false,
    };

    if (!currentExam) {
      return JSON.stringify(status);
    }

    const submissionCollection = await getCollection(Submission);
    const submissionCount = await submissionCollection.countDocuments({ examId: currentExam._id });

    status.submissions = submissionCount > 0;
    status.masterSolution = !!(currentExam.masterSolutionIds && currentExam.masterSolutionIds.length > 0);
    status.gradingScheme = !!(currentExam.gradingSchemeIds && currentExam.gradingSchemeIds.length > 0);
    status.blankExam = !!(currentExam.blankExamIds && currentExam.blankExamIds.length > 0);

    return JSON.stringify(status);
  },
});
